import { render } from "./HeroiconsSolidTicket.vue?vue&type=template&id=8a345374"
const script = {}

import exportComponent from "/Users/larkinwhitaker/Projects/eye-rep/modules/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidTicket.vue"]])

export default __exports__